import React, {PureComponent} from 'react';
import {Col, Container, Row} from 'reactstrap';
import {connect} from 'react-redux';
import LoadingProgress from '../../components/LoadingProgress';
import {withRouter} from 'react-router-dom';
import Alert from '../../components/Alert';
import ProvidersTable from '../../pages/providers/components/ProvidersTable';
import ReactQueryParams from 'react-query-params';
import * as TextManager from "../../modules/languages/TextManager";
import {fetchProvidersDataIfNeeded} from "../../redux/actions/ProvidersActions";



class Providers extends ReactQueryParams {

    constructor(props) {
        super(props);
        
    }

    componentDidMount() {
        this.props.dispatch(fetchProvidersDataIfNeeded());
    }

    render() {

        return (
            <Container className='sales'>

                <style>
                    {`
                        .card-body {
                        box-shadow: 0 10px 30px 1px rgba(0, 0, 0, 0.06);
                        }
                    `}
                </style>

                {this.props.status === 'request' &&
                <Row>
                    <LoadingProgress/>
                </Row>}

                {this.props.status === 'error' &&
                <Row>
                    <Alert color='danger' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span></p>
                        <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                    </Alert>
                </Row>}

                {this.props.status === 'no_permission' &&
                <Row>
                    <Alert color='warning' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.loginFailed}</span>
                            {TextManager.getCurrentTextResource().Text.pleaseRefreshThePage}</p>
                    </Alert>
                </Row>}

                {this.props.status === 'success' &&
                <Row>
                    <Col md={12} lg={12}>
                        <ProvidersTable/>
                    </Col>
                </Row>}

            </Container>
        )

    }

}


const mapStateToProps = (state) => {
    return {
        data: state.providers.data,
        status: state.providers.status,
        userData: state.userData
    };
};

export default withRouter(connect(mapStateToProps)(Providers))